import { PostCardAuthorFragmentFragment } from '@/__generated__/graphql';
import { PostAuthor } from './post-author';
import { postCardHeader, postCardHeaderContent } from './post-card.css';

type PostCardHeaderProps = {
  author: PostCardAuthorFragmentFragment;
  actions?: React.ReactNode;
  isAuthorClickable?: boolean;
};
export const PostCardHeader = ({
  actions,
  author,
  isAuthorClickable = true,
}: PostCardHeaderProps) => {
  return (
    <div className={postCardHeader}>
      <div className={postCardHeaderContent}>
        <PostAuthor clickableAuthor={isAuthorClickable} author={author} />
      </div>

      {actions}
    </div>
  );
};
